// EZ Analyzer — React entry point.
//
// Mounts the App into #ez-analyzer-root, which Flask renders in
// Templates/ez_listing_analyzer.html. Kept tiny on purpose — anything
// substantive belongs in App.jsx so it gets bundled cleanly.

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';

const root = document.getElementById('ez-analyzer-root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
} else {
  // Fail loudly in the console so a missing mount point doesn't
  // produce a silent blank page in production.
  console.error(
    '[EZ Analyzer] #ez-analyzer-root not found — Flask template missing?',
  );
}
